import { useEffect, useState } from "react";
import { getProductInfo } from "src/utils/storage/product";
import { useRecoilState } from "recoil";
import { navStepAtom, userInfoAtom } from "src/atoms";
import { useGetMySiteStatus } from "src/hooks/recoil/useGetMySiteStatus";
import SitePromotionUI from "./SitePromotion.presenter";

interface ISitePayContainerProps {}

// 모든 제품 공용으로 사용하게 리팩토링
const SitePromotionContainer = () => {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const [isRenew, setIsRenew] = useState(false);
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  // 추후 쓸일있을지 검토
  const [isApplyDone, setIsApplyDone] = useState(false);
  // 요새 안쓰는 UI (프로모션 코드가 적용되었습니다.)
  const [isCreateDone, setIsCreateDone] = useState(false);
  const [isHasSite, setIsHasSite] = useState(true);
  const [toggleAskPromotionOn, setToggleAskPromotionOn] = useState(false);

  const { getMySiteStatus } = useGetMySiteStatus();
  useEffect(() => {
    async function init() {
      setNavStep(2); // 구독 결제정보 입력
      await getMySiteStatus({});
      window.sessionStorage.removeItem("payType");
    }
    init();
  }, []);
  return (
    <SitePromotionUI
      toggleAskPromotionOn={toggleAskPromotionOn}
      setToggleAskPromotionOn={setToggleAskPromotionOn}
    />
  );
};

export default SitePromotionContainer;
